import React from 'react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { TabsContent } from '../../components/ui/tabs';
import { RefreshCw, Hammer, Clock, AlertTriangle } from 'lucide-react';
import { fmt } from './constants';

const BreakTab = ({ role, breakablePieces, onRefresh, onOpenBreak }) => (
  <TabsContent value="break" className="mt-3">
    <div className="bg-white rounded-xl shadow border border-amber-100">
      <div className="p-3 border-b flex items-center gap-2">
        <h2 className="font-semibold text-amber-900 text-sm mr-auto">
          {role === 'metal_inventory_assistant' ? 'Pieces to Break' : 'All Issued Pieces'}
        </h2>
        <Button variant="outline" size="icon" onClick={onRefresh} className="h-10 w-10" data-testid="break-refresh-btn">
          <RefreshCw className="w-4 h-4" />
        </Button>
      </div>
      <div className="divide-y" data-testid="break-table-body">
        {breakablePieces.length === 0 && (
          <div className="text-center py-6 text-slate-400 text-sm">Nothing to break right now</div>
        )}
        {breakablePieces.map((p) => {
          const override = p.shortage_override_request;
          const overridePending = override && override.status === 'pending';
          const overrideRejected = override && override.status === 'rejected';
          return (
            <div key={p._id} className="p-3 flex items-center gap-3" data-testid={`break-row-${p.serial_no}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-mono text-xs">{p.serial_no}</span>
                  {p.breakage_draft && !overridePending && !overrideRejected && (
                    <Badge className="bg-yellow-100 text-yellow-800">Draft</Badge>
                  )}
                  {overridePending && (
                    <Badge className="bg-amber-100 text-amber-800" data-testid={`break-pending-approval-${p.serial_no}`}>
                      <Clock className="w-3 h-3 mr-1" /> Awaiting admin approval
                    </Badge>
                  )}
                  {overrideRejected && (
                    <Badge className="bg-rose-100 text-rose-800" data-testid={`break-override-rejected-${p.serial_no}`}>
                      <AlertTriangle className="w-3 h-3 mr-1" /> Rejected — recount
                    </Badge>
                  )}
                </div>
                <div className="text-xs text-slate-500 mt-0.5 truncate">
                  {p.branch} · {fmt(p.gross_weight)} gm · {fmt(p.expected_purity, 2)}% · {p.lot_no}
                </div>
                {overrideRejected && override.rejection_note && (
                  <div className="text-[11px] text-rose-700 mt-0.5">
                    Admin: {override.rejection_note}
                  </div>
                )}
                {p.breakage_draft && role !== 'metal_inventory_assistant' && !overridePending && (
                  <div className="text-[10px] text-yellow-700 mt-0.5">
                    Draft by {p.breakage_draft.saved_by_name || 'unknown'}
                  </div>
                )}
              </div>
              <Button
                size="sm"
                className="h-10 bg-amber-700 hover:bg-amber-800"
                onClick={() => onOpenBreak(p)}
                disabled={overridePending}
                data-testid={`break-open-${p.serial_no}`}
                title={overridePending ? 'Locked until admin approves or rejects' : ''}
              >
                <Hammer className="w-4 h-4 sm:mr-1" /> <span className="hidden sm:inline">Break</span>
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  </TabsContent>
);

export default BreakTab;
